import React, { useState } from 'react';
import {
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  Button,
} from 'react-bootstrap';
import ImageGallery from './components/ImageGallery';
import ProductsPage from './components/ProductsPage';
import OrderForm from './components/OrderForm';
import FAQPage from './components/FAQPage';
import ContactPage from './components/ContactPage';
import WorkShowcase from './components/WorkShowcase';
import { siteData, getDefaultWhatsappUrl } from './data/siteData';
import { createOrderMessengerUrl } from './data/orderFormData';
import './App.css';

/*
======= سوشيال ميديا احترافية لجلب الزيارات وتحسين السيو =======

 العربية:
- احصلي على أرقى الملابس النسائية الآن مع توصيل مجاني لكل ولايات الجزائر!
- جُربي تشكيلتنا الجديدة واستمتعي بأناقة مثالية وجودة تدوم طويلاً
- عروض خاصة وخصومات منتظركِ لدى moda-lady – أسرعي بالحجز الآن!

Français:
- Commandez vos vêtements de luxe avec livraison gratuite partout en Algérie !
- Essayez notre nouvelle collection et profitez d’une élégance parfaite et d’une qualité durable
- Offres spéciales et réductions chez moda-lady – Réservez vite !

English:
- Get your luxury clothing now with free delivery to all Algerian regions!
- Try our new collection and enjoy perfect elegance with long-lasting quality
- Special offers and discounts await you at moda-lady – Order now!
==========================================================
*/

function App() {
  // الحصول على رابط واتساب الافتراضي
  const whatsappUrl = getDefaultWhatsappUrl();
  const defaultMessengerUrl = createOrderMessengerUrl({ fullName: '', phone: '', state: '', municipality: '', notes: '', size: '', color: '', product: 'استفسار عام/بطلب المنتج' });

  // حالة الصفحة الحالية
  const [currentPage, setCurrentPage] = useState('home');

  // دالة للتنقل بين الصفحات
  const navigateToPage = (page) => {
    setCurrentPage(page);
  };

  // إذا كانت الصفحة الحالية هي المنتجات، اعرض صفحة المنتجات
  if (currentPage === 'products') {
    return <ProductsPage onNavigate={navigateToPage} />;
  }

  // إذا كانت الصفحة الحالية هي نموذج الطلب، اعرض صفحة نموذج الطلب
  if (currentPage === 'order') {
    return <OrderForm onNavigate={navigateToPage} />;
  }

  // إذا كانت الصفحة الحالية هي FAQ، اعرض صفحة FAQ
  if (currentPage === 'faq') {
    return <FAQPage onNavigate={navigateToPage} />;
  }

  // إذا كانت الصفحة الحالية هي اتصل بنا، اعرض صفحة اتصل بنا
  if (currentPage === 'contact') {
    return <ContactPage onNavigate={navigateToPage} />;
  }


  return (
    <div className="App" dir="ltr">
      {/* Header */}
      <Navbar bg="light" expand="lg" className="custom-navbar" fixed='top'>
        <Container>
          <Navbar.Brand href="#home" className="brand-text">
            {siteData.siteName}
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link onClick={() => navigateToPage('home')}>الرئيسية</Nav.Link>
              <Nav.Link href='#gallery-section'>المنتجات</Nav.Link>
              <Nav.Link href='#section'>معرض الأعمال</Nav.Link>
              <Nav.Link href='#order-form'>اطلب الآن</Nav.Link>
              <Nav.Link href='#testimonials-section'>الأسئلة</Nav.Link>
              <Nav.Link href='#footer-section'>اتصل بنا</Nav.Link>
              <Nav.Link onClick={() => navigateToPage('color-extractor')}>أداة الألوان</Nav.Link>
            </Nav>
            <div className="d-flex flex-column flex-md-row gap-2 align-items-stretch w-100" style={{ maxWidth: 350 }}>
              <Button
                variant="primary"
                className="cta-button px-4 py-2 flex-fill"
                href={whatsappUrl}
                target="_blank"
                style={{ minWidth: 0, width: '100%' }}
              >
                اطلبي الآن
              </Button>
              <Button
                className="cta-button px-4 py-2 flex-fill mt-2 mt-md-0"
                style={{ backgroundColor: '#2F3E46', border: 'none', borderRadius: '8px', color: '#fff', marginRight: '8px', minWidth: 0, width: '100%', display: 'flex', alignItems: 'center' }}
                as="a"
                href={defaultMessengerUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="اطلبي عبر ماسنجر"
                onMouseOver={e => e.currentTarget.style.opacity = 0.9}
                onMouseOut={e => e.currentTarget.style.opacity = 1}
              >
                <i className="bi bi-messenger me-2" aria-hidden="true"></i>
                اطلبي عبر ماسنجر
              </Button>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* البانر الرئيسي */}
      <section className="hero-section hero-bg" style={{ backgroundImage: `url(${siteData.heroContent.mainImage})` }}>
        <div className="hero-overlay-content-container">
          <div className="hero-content text-end">
            <h1 className="hero-title">
              {siteData.heroContent.title}
            </h1>
            <div className="d-flex flex-column flex-md-row gap-2 align-items-stretch w-100" style={{ maxWidth: 350 }}>
              <Button
                variant="primary"
                size="lg"
                className="hero-cta-button px-4 py-2 flex-fill"
                href={whatsappUrl}
                target="_blank"
                style={{ minWidth: 0, width: '100%' }}
              >
                {siteData.heroContent.ctaText}
              </Button>
              <Button
                className="hero-cta-button px-4 py-2 flex-fill mt-2 mt-md-0"
                style={{ backgroundColor: '#2F3E46', border: 'none', borderRadius: '8px', color: '#fff', marginRight: '8px', minWidth: 0, width: '100%', display: 'flex', alignItems: 'center' }}
                as="a"
                href={defaultMessengerUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="اطلبي عبر ماسنجر"
                onMouseOver={e => e.currentTarget.style.opacity = 0.9}
                onMouseOut={e => e.currentTarget.style.opacity = 1}
              >
                <i className="bi bi-messenger me-2" aria-hidden="true"></i>
                اطلبي عبر ماسنجر
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* قسم المميزات */}
      <section className="features-section">
        <Container>
          <Row>
            {siteData.features.map((feature, index) => (
              <Col md={3} sm={6} key={index} className="text-center mb-4">
                <div className="feature-card">
                  <div className="feature-icon">{feature.icon}</div>
                  <h4 className="feature-title">{feature.title}</h4>
                  <p className="feature-description">{feature.description}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* معرض صور المنتج */}
      <section className="gallery-section" id='gallery-section'>
        <Container>
          <h2 className="section-title text-center mb-5">صور الملابس</h2>
          <ImageGallery images={siteData.productImages} title="صور منتجات moda-lady" />
        </Container>
        <ProductsPage />
      </section>

      {/* هنا معرض الأعمال فوق آراء العملاء */}

      <section id='section'>
        <WorkShowcase />
      </section>

      <section id="faq-section">
        <FAQPage />
      </section>

      <section id="order-form">
        <OrderForm />
      </section>

      {/* Footer */}
      <footer className="footer-section" id='footer-section'>
        <Container>
          <ContactPage />

        </Container>
      </footer>
    </div>
  );
}

export default App;